<!-- @format -->

<template>
  <div>
    <sui-modal v-model="showAssumptions">
      <sui-modal-header>Capital Market Assumptions</sui-modal-header>
      <sui-modal-content>
        <AssumptionsV2
          :aaType="aaType"
          :assumptions="assumptions"
          v-if="aaType != 'ExtendedCustom' || canEdit == false"
        />

        <AssumptionsV2Edit
          :aaType="aaType"
          :assumptions="assumptions"
          v-if="aaType == 'ExtendedCustom' && canEdit == true"
        />
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button @click.native="showAssumptions = false">Close</sui-button>
      </sui-modal-actions>
    </sui-modal>
    <div class="ui attached message">
      <div class="header">Percentile Ranges</div>
    </div>
    <div class="ui attached segment">
      <div class="ui">
        <div class="ui">
          <strong> <label>More Likely Range</label></strong>
          <br />

          <v-select
            label="text"
            :reduce="(z) => z.value"
            @input="handleZScoreChanged"
            v-model="moreLikelyZScore"
            :options="zScores"
          >
            <template v-slot:option="option">{{ option.text }}</template>
          </v-select>

          <div class="ui " v-if="false">
            <div class="ui ">
              <strong> <label>Colour & Opacity</label></strong
              ><br />
              <div class="ui labeled input">
                <div class="ui label">
                  <v-swatches
                    :trigger-style="{ width: '20px', height: '20px' }"
                    show-fallback
                    fallback-input-type="color"
                    popover-x="left"
                    v-model="appearanceSettings.appearanceSchema.graphColor"
                  ></v-swatches>
                </div>
                <input
                  class="ui input"
                  v-model="
                    appearanceSettings.appearanceSchema.graphColorOpacity
                  "
                />
              </div>
            </div>
          </div>

          <label><strong>Less Likely Range</strong></label>
          <br />

          <v-select
            label="text"
            :reduce="(z) => z.value"
            @input="handleZScoreChanged"
            v-model="lessLikelyZScore"
            :options="zScores"
          >
            <template v-slot:option="option">{{ option.text }}</template>
          </v-select>

          <div v-if="false">
            <strong> <label>Colour & Opacity</label></strong
            ><br />
            <div class="ui labeled input">
              <div class="ui label">
                <v-swatches
                  :trigger-style="{ width: '20px', height: '20px' }"
                  show-fallback
                  fallback-input-type="color"
                  popover-x="left"
                  v-model="appearanceSettings.appearanceSchema.graphColorRange2"
                ></v-swatches>
              </div>
              <input
                class="ui input"
                v-model="appearanceSettings.appearanceSchema.graphColorOpacity2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="ui top attached message"
      v-if="
        partnerId == 5 ||
          partnerId == 17 ||
          partnerId == 29 ||
          partnerId == 19 ||
          partnerId == 51
      "
    >
      <div class="header">Capital Market Assumptions</div>
    </div>
    <div
      class="ui attached segment"
      v-if="
        partnerId == 5 || partnerId == 17 || partnerId == 29 || partnerId == 19
      "
    >
      <div class="ui">
        <div class="ui">
          <strong>
            <label>Long-term projected returns & volatility </label></strong
          >
          <a
            href="#"
            v-if="aaType != 'ExtendedCustom' || canEdit == false"
            @click.prevent="showAssumptions = true"
            >More Info</a
          >
          <a
            href="#"
            v-if="aaType == 'ExtendedCustom' && canEdit == true"
            @click.prevent="showAssumptions = true"
            >Edit</a
          >
          <br />

          <v-select
            label="text"
            :reduce="(z) => z.value"
            @input="handleZScoreChanged"
            v-model="aaType"
            :options="aaTypes"
          >
            <template v-slot:option="option">{{ option.text }}</template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="ui  segment">
      <div class="ui toggle checkbox">
        <input
          type="checkbox"
          @change="handleZScoreChanged"
          name="public"
          v-model="isFundAlphaEqualToFees"
        />
        <label
          >Portfolio alpha return 0%
          <strong v-if="isFundAlphaEqualToFees">after TIC</strong
          ><strong v-else>before TIC</strong>
        </label>
      </div>
      <br />
      <small v-if="!isFundAlphaEqualToFees"
        >For projections, a long-term expected alpha returns of 0%
        <strong> before taking into account investment fees/TIC </strong> is
        used.
      </small>
      <small v-if="isFundAlphaEqualToFees"
        >For projections, a long-term expected alpha returns of 0%
        <strong>after taking into account investment fees/TIC </strong> is
        used.</small
      >
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
import VSwatches from "vue-swatches";
import {
  getPartnerSettings,
  getPartnerCapitalMarketAssumptions,
} from "@/gateway";
import AssumptionsV2 from "@/components/AssumptionsV2.vue";

import AssumptionsV2Edit from "@/components/AssumptionsV2Edit.vue";
export default {
  name: "Testing",
  components: { vSelect, VSwatches, AssumptionsV2, AssumptionsV2Edit },
  props: [
    "canEdit",
    "moreLikelyZScore",
    "lessLikelyZScore",
    "showLowestProjectedOutcome",
    "appearanceSettings",
    "isFundAlphaEqualToFees",
    "aaType",
    "currency",
  ],
  data() {
    // 2.326 -- 99th percentile
    // 1.645 - 95th percentile
    // 1.282 - 90th percentile
    // 1.6449 - 85th percentile
    // 0.674 - 75h percentile
    // 0.8416 - 60th percenetile
    // 0.125 - 55th percentile
    return {
      showAssumptions: false,
      zScores: [
        { text: "1st & 99th Percentile", value: 2.5758 },
        { text: "5th & 95th Percentile", value: 1.96 },
        { text: "10th & 90th Percentile", value: 1.6449 },
        { text: "15th & 85th Percentile", value: 1.4395 },
        { text: "25th & 75th Percentile", value: 1.1503 },
        { text: "40th & 60th Percentile", value: 0.8416 },
        { text: "45th & 55th Percentile", value: 0.7554 },
      ],
      aaTypes: [
        { text: "2019-2020 Long-term returns (infl 5%)", value: "Simple2" },
        { text: "2019-2020 Long-term returns (infl 5.5%)", value: "Simple" },

        { text: "2021 Broad (infl 5%)", value: "Extended" },
        { text: "2021 Broad (infl 5.5%)", value: "Extended2" },
        { text: "In-house long-term assumptions", value: "ExtendedCustom" },
      ],
      assumptions: null,
    };
  },
  computed: {
    partnerId() {
      return this.$store.state.partnerId;
    },
  },
  methods: {
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else return numeral(val).format("0,0");
    },
    async handleZScoreChanged(selected) {
      const capMR = await getPartnerCapitalMarketAssumptions({
        aaType: this.aaType,
        currency: this.currency || "ZAR",
      });
      if (capMR) {
        this.assumptions = capMR;
      }

      this.$emit("handleZScoreChanged", {
        moreLikelyZScore: this.moreLikelyZScore,
        lessLikelyZScore: this.lessLikelyZScore,
        showLowestProjectedOutcome: this.showLowestProjectedOutcome,
        isFundAlphaEqualToFees: this.isFundAlphaEqualToFees,
        aaType: this.aaType,
      });
    },

    async init() {
      if (!this.moreLikelyZScore) {
        const partnerSetResponse = await getPartnerSettings();
        if (partnerSetResponse) {
          this.moreLikelyZScore =
            partnerSetResponse.partnerDefaultSettings.moreLikelyZScore;
          this.lessLikelyZScore =
            partnerSetResponse.partnerDefaultSettings.lessLikelyZScore;
          this.showLowestProjectedOutcome =
            partnerSetResponse.partnerDefaultSettings.showLowestProjectedOutcome;

          this.isFundAlphaEqualToFees =
            partnerSetResponse.partnerDefaultSettings.isFundAlphaEqualToFees;
          this.aaType = partnerSetResponse.partnerDefaultSettings.aaType;
        }
      }
      const capMR = await getPartnerCapitalMarketAssumptions({
        aaType: this.aaType,
        currency: this.currency || "ZAR",
      });
      if (capMR) {
        this.assumptions = capMR;
      }
      // this.riskProfile = this.riskProfiles[0];
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
